import { InferOutput, uuid, pipe, string } from 'valibot'

export const UuidStringSchema = pipe(string(), uuid())

export type UuidString = InferOutput<typeof UuidStringSchema>
